import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import APIUtilities from './APIUtilities.js'
import SkeletonCard from "./SkeletonCard";
import { track } from './posthog';
import { Button , Modal, Result} from 'antd';

import { CaretLeftOutlined } from '@ant-design/icons';
import { CaretRightOutlined } from '@ant-design/icons';

import "./RDVResults.css";


const formatter = new Intl.DateTimeFormat("fr-FR", {
  weekday: "long",
  day: "numeric",
  month: "long"
});

const SELECT_RDV_CHOICE   = 0;
const VALID_RDV_CHOICE    = 1;
const FINAL_PAGE_RDV      = 2;

export default class RDVResults extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {

      firstLoad : true,
      numberWeek : 0,
      year : 0,
      creneau_LIST : [],
      horaire_LIST : [],
      dateCurrent : undefined,
      dateDay1 : undefined,
      stepRDV : SELECT_RDV_CHOICE,
      selectedCreneau : undefined,
      showModal : false

    };
  };

  static propTypes = {
    onClickFunction: PropTypes.func,
    reparation: PropTypes.object
  };

  // Récap simple de la réparation (marque, modèle, prestations) affiché en tête de la page RDV
  // lorsqu'on ouvre le module directement sur cette étape depuis un lien SMS.
  renderRecapReparation() {
    const reparation = this.props.reparation;

    if (!reparation)
      return null;

    return (
      <div className="recap_reparation_rdv">
        <div className="results-title">
          {reparation.marque} {reparation.modele}
        </div>
        <ul className="recap_reparation_prestations">
          {reparation.prestations && reparation.prestations.map((prestation, index) => (
            <li key={index}>
              {prestation.libelle} — {prestation.prixTTC} €
            </li>
          ))}
        </ul>
      </div>
    );
  }


  componentDidMount() {




    let dateCurrent = new Date();
    let dateDay1  = new Date();


    if( this.props.IsStockPieceDispo == true) {
      dateCurrent   = new Date(dateCurrent.setDate(dateCurrent.getDate() + 1));
      dateDay1      = new Date(dateDay1.setDate(dateDay1.getDate() + 1));
    }else{
      dateCurrent   = new Date(dateCurrent.setDate(dateCurrent.getDate() + 2));
      dateDay1      = new Date(dateDay1.setDate(dateDay1.getDate() + 2));
    }

   
    var result = this.getWeekNumber(dateCurrent);
    this.state.dateCurrent = dateCurrent;
    this.setState({dateDay1, dateCurrent,  year : result[0], numberWeek : result[1]})
    
   // console.log('getWeekNumber');
   // console.log(result);
   // console.log(this.getMondayAndSaturday(result[1], result[0]));

    // À l'arrivée sur la page : sauter automatiquement au premier jour ouvert.
    this.avancerJourOuvert = true;
    this.generateCreneau();
    this.getCrenauList();

  }

  generateCreneau(){
    


      let creneau_LIST = [];

      /*
      for (let index = 0; index < 6; index++) {
        console.log(index)

        let horaire_LIST = []

        horaire_LIST.push({HeureDebut : '11:00:00'}, {HeureFin : '12:00:00'})
        horaire_LIST.push({HeureDebut : '12:00:00'},  {HeureFin : '13:00:00'})
        horaire_LIST.push({HeureDebut : '14:00:00'},  {HeureFin : '15:00:00'})
        horaire_LIST.push({HeureDebut : '15:00:00'},  {HeureFin : '16:00:00'})
        horaire_LIST.push({HeureDebut : '16:00:00'},  {HeureFin : '17:00:00'})
        
        let creneau = {
          NumSemaine : semaine ,
          NumJourSemaine : index +1,
          LibelleJour : this.getLibelleJourByNumero(index +1),
          Horaire_LIST : horaire_LIST
        }
        creneau_LIST.push(creneau)

      }
      */
     // console.log(creneau_LIST)


      // Les créneaux viennent du CRM (Paramétrages > Ouvertures) : semaine type
      // de la boutique, fermetures exceptionnelles, durée de créneau et
      // profondeur de la fenêtre. Plus aucune règle d'ouverture ici.
      // Capturer le flag AVANT le setState : son callback est asynchrone et le
      // flag est réarmé à false immédiatement (une seule avance auto, à l'arrivée).
      const vl_avancerJourOuvert = this.avancerJourOuvert === true;
      this.avancerJourOuvert = false;
      this.setState({creneau_LIST}, () => this.chargerCreneaux(vl_avancerJourOuvert));
  }


  async chargerCreneaux(pe_avancerJourOuvert){

    const dateCurrent = new Date(this.state.dateCurrent);
    const IDSite      = this.props.IDSite;

    this.setState({chargementCreneau : true});

    const slotList = await APIUtilities.getTimeSlots(dateCurrent, IDSite);

    const jour_LIST = (slotList && slotList.periode_LIST) ? slotList.periode_LIST : [];

    // Ouverture de la page uniquement : si la date d'arrivée n'a aucun créneau
    // (boutique fermée ce jour-là), avancer automatiquement au premier jour
    // ouvert de la fenêtre renvoyée par l'API. Les flèches de navigation ne
    // déclenchent pas ce comportement (l'utilisateur choisit sa date).
    if (pe_avancerJourOuvert === true && jour_LIST.length > 0) {
      const premierJourOuvert = jour_LIST.find(function(jour) {
        return jour.periode_LIST && jour.periode_LIST.length > 0;
      });

      if (premierJourOuvert && premierJourOuvert !== jour_LIST[0]) {
        const nouvelleDate = new Date(premierJourOuvert.date);
        if (!isNaN(nouvelleDate.getTime())) {
          this.setState({
            dateCurrent: nouvelleDate,
            horaire_LIST: premierJourOuvert.periode_LIST,
            chargementCreneau: false
          });
          return;
        }
      }
    }

    // L'API renvoie la date demandée en premier, suivie des jours suivants.
    const jourCourant  = jour_LIST.length > 0 ? jour_LIST[0] : null;
    const horaire_LIST = (jourCourant && jourCourant.periode_LIST) ? jourCourant.periode_LIST : [];

    // Aucun créneau = boutique fermée ce jour-là. Sans event, ce cas resterait
    // invisible : on ne saurait pas combien de clients tombent sur une journée
    // vide et repartent.
    if(horaire_LIST.length === 0){
      track('devis_rdv_aucun_creneau', {
        IDSite : IDSite,
        date : jourCourant ? jourCourant.date : undefined,
      });
    }

    this.setState({horaire_LIST, chargementCreneau : false});
  }

  getLibelleJourByNumero(pe_numeroSemaine){

    if(pe_numeroSemaine == 1){
      return "Lundi"
    }
    if(pe_numeroSemaine == 2){
      return "Mardi"
    }
    if(pe_numeroSemaine == 3){
      return "Mercredi"
    }
    if(pe_numeroSemaine == 4){
      return "Jeudi"
    }
    if(pe_numeroSemaine == 5){
      return "Vendredi"
    }
    if(pe_numeroSemaine == 6){
      return "Samedi"
    }

  }

  formaterDate = (date) => {
    return formatter.format(date);
  };

  getMondayAndSaturday(weekNumber, year) {

    const firstDayOfYear = new Date(year, 0, 1);
    const daysOffset = (weekNumber - 1) * 7; // Nombre de jours à ajouter pour atteindre la semaine demandée

    // Trouver le premier lundi de l'année
    const firstMonday = new Date(firstDayOfYear);
    firstMonday.setDate(firstDayOfYear.getDate() + (firstDayOfYear.getDay() === 0 ? 1 : (8 - firstDayOfYear.getDay())));

    // Calcul des dates du lundi et samedi de la semaine donnée
    const monday = new Date(firstMonday);
    monday.setDate(firstMonday.getDate() + daysOffset);

    const saturday = new Date(monday);
    saturday.setDate(monday.getDate() + 5);

    return {
        monday: monday.toISOString().split('T')[0], // Format YYYY-MM-DD
        saturday: saturday.toISOString().split('T')[0]
    };
  
  }

  getWeekNumber(d) {
        // Copy date so don't modify original
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
        // Get first day of year
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
        // Calculate full weeks to nearest Thursday
        var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
        // Return array of year and week number
        return [d.getUTCFullYear(), weekNo];
  }

  async getCrenauList() {
    const list = await APIUtilities.generateCreneauList('a8bca01-f284-6736-66b0-a8fad4ae1481');
    console.log(list)

    this.setState({
      firstLoad : false,
      categoryList : list
    });
  }

  selectCategory(category) {
    this.props.onClickFunction(category);
  };

  renderDateSelecteur(){

    return this.formaterDate(this.state.dateCurrent).charAt(0).toUpperCase() + this.formaterDate(this.state.dateCurrent).slice(1);   

  }

  addDay(){

    let dateCurrent = new Date(this.state.dateCurrent);
    console.log('dateCurrent',dateCurrent);
    dateCurrent = dateCurrent.setDate(dateCurrent.getDate() + 1);
    console.log('dateCurrent',dateCurrent);
    this.state.dateCurrent = dateCurrent;
   this.setState({dateCurrent});
   this.reloadCreneau();
   
  }

  prevDay(){
    console.log('prevDay')
    let dateCurrent = new Date(this.state.dateCurrent);
    console.log('dateCurrent',dateCurrent);
    dateCurrent = dateCurrent.setDate(dateCurrent.getDate() - 1);
    this.state.dateCurrent = dateCurrent;
    this.setState({dateCurrent});
    this.reloadCreneau();
  }

  reloadCreneau(){
    var result = this.getWeekNumber(new Date(this.state.dateCurrent));
    this.generateCreneau();
  }

  selectCreneau(item){
    console.log(item);
    track('devis_creneau_selectionne', { IDSite: this.props.IDSite, creneau_heure: item.LibelleDebut });
    this.state.selectedCreneau = item;
    this.setState({selectedCreneau : item, showModal : true})

    //let dateCreneau = new Date(this.state.dateCurrent);

  }


  formatDateToSQL(dateInput) {

    // L'API renvoie déjà l'heure locale de la boutique au format SQL
    // ('AAAA-MM-JJ HH:MM:SS'). La repasser dans new Date() est inutile et échoue
    // sur certains navigateurs (format non ISO) : on la renvoie telle quelle.
    if(typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateInput))
      return dateInput;

    const date = new Date(dateInput);

    if (isNaN(date.getTime())) {
        throw new Error("Date invalide");
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}



  handleOk = () => {
   // setIsModalOpen(false);

  

   let selectedCreneau =  this.state.selectedCreneau;
   selectedCreneau.DateDebutCreneau   = this.formatDateToSQL(selectedCreneau.DateDebutCreneau);
   selectedCreneau.DateFinCreneau     = this.formatDateToSQL(selectedCreneau.DateFinCreneau);

   track('devis_rdv_confirme', {
     IDSite: this.props.IDSite,
     creneau_date: selectedCreneau.DateDebutCreneau,
     creneau_heure: selectedCreneau.LibelleDebut,
   });

   APIUtilities.sendDemandeRDVDevisV2(this.props.GUID, this.state.selectedCreneau);

   this.handleCancel();

   this.setState({stepRDV : FINAL_PAGE_RDV }) 
  };

  handleCancel = () => {
   // setIsModalOpen(false);
   this.setState({showModal : false})
  };



  render() {

    if(this.state.firstLoad)
      return <SkeletonCard nbItems="4"/>;
    else {
      return (
        <>

        { this.state.stepRDV == SELECT_RDV_CHOICE &&
          this.renderRecapReparation()
        }

        { this.state.stepRDV == SELECT_RDV_CHOICE &&
          <div className="results-title">
            Réservez votre créneau dès maintenant
          </div>
        }

        { this.state.stepRDV == SELECT_RDV_CHOICE &&
               <div className="wapper_rdv">

               <div className="dateSelectRDV">
                 { this.state.dateCurrent > new Date(this.state.dateDay1) &&
                   <span onClick={() => this.prevDay()} ><CaretLeftOutlined style = {{visible : 'none'}} /></span>
                 }
                 {this.renderDateSelecteur()}<span onClick={() => this.addDay()}><CaretRightOutlined /></span>
               </div>
     
                 {
                 this.state.horaire_LIST.map(category => (
                   <div>
                        <Button onClick={ () => this.selectCreneau(category) } className="button_rdv">{category.LibelleDebut}</Button>
                   </div>
                   ))
                 }

                 { this.state.chargementCreneau !== true && this.state.horaire_LIST.length === 0 &&
                   <div className="aucun_creneau_rdv">
                     La boutique est fermée ce jour-là. Choisissez une autre date avec la flèche ci-dessus.
                   </div>
                 }
               
             </div>
        }

        { this.state.showModal == true &&
        <Modal 
          title="Valider mon rendez-vous" 
          open={this.state.showModal} 
          onOk={this.handleOk} 
          onCancel={this.handleCancel}
          okText="Valider"
          cancelText="Annuler"
          cancelButtonProps={{style: {color : '#1677FF', backgroundColor: 'white'}}}
          >
          <p>{'Prendre votre rendez-vous le ' + this.formaterDate(this.state.dateCurrent) + ' à ' + this.state.selectedCreneau.LibelleDebut + " ?"}</p>
        </Modal>
        }
     


      { this.state.stepRDV == VALID_RDV_CHOICE &&
          <div className="wapper_rdv">
          <div>
            <h3>Résumé de votre rendez-vous</h3>
            <div className="dateValideRDV">
             {'Prendre rendez-vous le ' + this.formaterDate(this.state.dateCurrent) + ' à ' + this.state.selectedCreneau.LibelleDebut + " ?"}
            </div>
          </div>
          </div>
      }

      {   this.state.stepRDV == FINAL_PAGE_RDV &&
          <div className="wapper_rdv">
            
            <Result
                status="success"
                title="Votre demande de rendez-vous a bien été prise en compte"
                subTitle="Notre équipe vous rappellera rapidement afin de valider votre créneau en fonction des stocks disponibles."
                extra={[
                  <a href="/">
                    <Button type="primary" key="console">
                    Nouveau devis
                    </Button>   
                  </a>
                ]}
              />
          </div>
      }
    



   

    
        </>
      );
    }
  }
}

/*
 //  {this.formaterDate(this.state.dateCurrent)} à {this.state.selectedCreneau.HeureDebut}
*/

/*
  this.setState({showModal : false})
*/